import { render, staticRenderFns } from "./freeList.vue?vue&type=template&id=50f48a17&scoped=true"
import script from "./freeList.vue?vue&type=script&lang=js"
export * from "./freeList.vue?vue&type=script&lang=js"
import style0 from "./freeList.vue?vue&type=style&index=0&id=50f48a17&prod&lang=css"
import style1 from "./freeList.vue?vue&type=style&index=1&id=50f48a17&prod&lang=css"
import style2 from "./freeList.vue?vue&type=style&index=2&id=50f48a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f48a17",
  null
  
)

export default component.exports